<template lang="html">
  <v-app>
    <NavDrawer />
    <AppBar />
    <v-main class="main-content">
      <v-container fluid class="main-container">
        <ModelViewer v-if="showModelViewer" />
        <router-view />
      </v-container>
    </v-main>
    <AppFooter />
  </v-app>
</template>

<script setup>
import AppFooter from "@/components/common/AppFooter.vue";
import NavDrawer from "@/components/common/NavDrawer.vue";
import AppBar from "@/components/common/AppBar.vue";
import ModelViewer from "@/components/viewer/ModelViewer.vue"
import { onMounted, computed } from "vue";
import {useStore} from "vuex";
import { useRoute } from 'vue-router'

const route = useRoute()
const store = useStore();

const showModelViewer = computed(() => !['HomeView', 'ArchitectProject', 'StructureProject', 'ProjectInformationView', 'CommentsView', 'ArchitectSettingsView'].includes(route.name) && ['architect', 'structure'].includes(store.state.user?.role))

onMounted(async () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    store.commit('setUserAgent', 'mobile');
  } else {
    store.commit('setUserAgent', 'desktop');
  }
  
  // Restore project and model from localStorage on app startup
  const savedProjectId = localStorage.getItem("projectId");
  const savedModelId = localStorage.getItem("modelId");
  
  if (savedProjectId && savedModelId) {
    // Restore project and model IDs to store
    await store.dispatch("handleProjectSelection", {id: savedProjectId, name: null});
    await store.dispatch('handleModelSelection', savedModelId)
    // Fetch the latest models for the project
    await store.dispatch("getOrCreateProject");
  }
  //TODOEB: Without the project and model Id we should redirect to the home page or project selection page
});
</script>

<style></style>